import BoxListButton from "@components/BoxListButton";
import { WEBINAR_DETAIL, WEBINAR_MODIFY } from "@constants/routes";
import { timestampToString } from "@helpers/dates.format";
import { IWebinar } from "@interfaces/webinar";

const listWebinarMapper = (items: IWebinar[], handleDelete: Function) =>
  items.map(({ uuid, title, date, createdAt }) => ({
    uuid,
    title,
    date: timestampToString(date),
    _dateTs: date ?? 0,
    createDate: timestampToString(createdAt),
    _createDateTs: createdAt ?? 0,
    actions: (
      <BoxListButton
        uuid={uuid}
        description={title}
        detailRoute={WEBINAR_DETAIL}
        modifyRoute={WEBINAR_MODIFY}
        handleDelete={handleDelete}
      />
    ),
  }));

export default listWebinarMapper;
